module.exports = __webpack_public_path__ + "img/1.859d6973.png";